export const style = {
  lead: {
    fontSize: `21px`,
    fontWeight: 300,
    fontHeight: 1.4,
    marginBottom: `20px`
  },
  p: {
    fontSize: `14px`,
    fontWeight: 400,
    lineHeight: `22px`,
    margin: `0 0 20px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Terms/style/paragraphs.js